import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const OptionsContainer = styled.div`
  position: absolute;
  background-color: ${({ theme }: { theme: Theme }) => theme.colors.select.optionsBackground};
  padding: 4px;
  top: calc(100% + 16px);
  left: 0;
  width: 100%;
  border-radius: 12px;
  z-index: 10;
  gap: 2px;
  display: flex;
  flex-direction: column;
`;
